import { gql } from '@apollo/client'

export const UPSERT_USER_SURVEY = gql`
  mutation upsertUserSurvey($userSurveyData: UserSurveyUpsertInput!) {
    upsertUserSurvey(userSurveyData: $userSurveyData) {
      id
      nonprofitOrgId
      response
      role
      type
    }
  }
`
